import { Injectable, OnDestroy } from "@angular/core";
import { AuthService } from "@evc/platform";
import { Subject } from "rxjs";
import { TENANT_ROLE } from "../../app.constants";
import { LoginUserServiceBase } from "../interfaces/login-user-contract.service";

@Injectable()
export class LoginUserOnlineService extends LoginUserServiceBase implements OnDestroy {
  private adminRoles = ["Owner", "Admin"];

  public readonly onLoginUserWrapper$ = new Subject<boolean>();

  constructor(private authService: AuthService) {
    super();
  }

  ngOnDestroy(): void {
    this.onLoginUserWrapper$.unsubscribe();
  }

  protected async loadUserProfile(): Promise<void> {
    const claims = this.authService.idTokenClaims();
    if (claims) {
      const userRole = claims.platformRoles as string;
      this._isAdminRole = this.adminRoles.includes(userRole);
      this._isGuestRole = userRole === TENANT_ROLE.GUEST;
      this._organizationId = this.authService.organizationId();
    }
  }
}
